import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button, Form, Input } from 'antd';
import { Translate } from 'react-jhipster';
import { getEleve, deleteEleve } from './eleve.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const EleveNotifModal = (props: RouteComponentProps<{ id: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const eleve = useAppSelector(state => state.eleve.entity);
  useEffect(() => {
    dispatch(getEleve(props.match.params.id));
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <Modal
      title="Notification à un parent"
      centered
      footer={[
        <Button key="back" onClick={goBack}>
          Annuler
        </Button>,
        <Button key="submit" type="primary">
          Envoyer
        </Button>,
      ]}
      visible={true}
      closable={false}
    >
      <Form labelCol={{ span: 4 }} wrapperCol={{ span: 24 }} layout="vertical" size="large">
        <Form.Item label="Destinataire">
          <Input disabled value={eleve.parent.firstName + ' ' + eleve.parent.lastName + ' ' + eleve.parent.telephone} />
        </Form.Item>
        <Form.Item label="Message">
          <Input.TextArea placeholder="Message" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EleveNotifModal;
